module.exports = __webpack_public_path__ + "media/images/contest-vote-title-d58420c1980d0b9734bd555215b22238.png";